export const loginErrorInformation: { [id: string]: string } = {
  userDoesNotExist: "User does not exist",
  invalidCredentials: "Credentials are invalid",
  userDoesNotExistOnHcpCommunity: "User does not exist",
  userRegisteredButNotVerifiedByTakeda: "Account is not yet verified by Takeda",
};
